<script lang="typescript">
  import type { NewActor } from './newMachine';
  import TypeForm from './TypeForm.svelte';
  export let machine:NewActor;
  const save = () => { machine.send({ type: 'SAVE' }); };
  $: values = machine.state.context.values;
  $: saving = machine.state.matches('saving');
  $: isError = machine.state.matches('error');
  $: error = machine.state.context.error;
</script>

<TypeForm {values} on:submit={save} {saving}/>

{#if isError}
  <div class="panel panel-error">
    <p>
    Virhe uuden tyypin tallennuksessa.
    </p>
    {@html error}
  </div>
{/if}


